/* tslint:disable */

/**
 */
export class StaffView {
    rfid?: string;
    user_name?: string;
    route_name?: string;
    role_name?: string;
    total_price_pos?: number;
    total_price_charge?: number;
    total_price_deposit?: number;
    total_revenue?: number;
}
